import { IObservable, Observable } from '@1js/oil-externals/rx';
import { Settings } from '../models/setting.model';
import { BaseSuggestionProvider } from './base.search-suggestion-provider';

export class SettingSearchSuggestionProvider extends BaseSuggestionProvider {
    public static settings: Settings;
    private static readonly languagePrefix = 'en';
    private static readonly MIN_NUM_OF_CHARS: number = 2;
    private static readonly MAXCOUNT: number = 2;

    public createStream(searchText: string): IObservable<any> {

        if (searchText?.trim() !== '') {
            const settings: Array<object> = [];
            const result: Array<object> = [];
            const text: string = searchText.replace(/\s/g, '').toLowerCase();

            if (SettingSearchSuggestionProvider.contextService.sharedContext.officeMarket.indexOf(SettingSearchSuggestionProvider.languagePrefix) === 0
                && text.length >= SettingSearchSuggestionProvider.MIN_NUM_OF_CHARS) {
                for (const setting of SettingSearchSuggestionProvider.settings.getSettingList()) {
                    const relatedSearchQueries: Array<string> = setting['RelatedSearchQueries'];
                    for (const searchQuery of relatedSearchQueries) {
                        const trimmedSearchQuery = searchQuery.replace(/\s/g, '').toLowerCase();
                        if ( text.indexOf(trimmedSearchQuery) === 0 || trimmedSearchQuery.indexOf(text) === 0) {
                            result.push(setting);
                            break;
                        }
                    }
                    if (result.length === SettingSearchSuggestionProvider.MAXCOUNT) {
                        break;
                    }
                }
            }

            result.forEach((setting, index) => {
                settings.push({
                    id: index.toString(),
                    isPwa: SettingSearchSuggestionProvider.capabilitiesService.capabilities.isPwaInUwp,
                    isDarkMode: SettingSearchSuggestionProvider.isDarkMode,
                    title: setting['Title'],
                    iconClass: setting['IconUnicodeCodepointCssClass'],
                    url: setting['Url'],
                    searchInstrumentationService: SettingSearchSuggestionProvider.searchInstrumentationService,
                    urlLauncherService: SettingSearchSuggestionProvider.urlLauncherService
                });
            });

            return Observable.fromArray(settings);
        }

        return Observable.empty();
    }

    public getId(): string {
        return 'setting';
    }
}
